'use strict';

/* Verhindert doppeltes Absenden des uebergebenen Formulars (Doppelklick / ungeduldiges erneutes
   Klicken, waehrend Logo und Bilder noch hochgeladen werden). Wird sowohl von der
   Selbstregistrierung (chip-map-registration.js, New.html) als auch von "Mein Eintrag"
   (chip-map-edit.js, Edit.html) genutzt. Bei der Registrierung liefen sonst zwei createAction()-
   Requests parallel, und beide koennten die "Benutzername/E-Mail bereits vergeben"-Pruefung im
   RegistrationRequestValidator passieren, bevor der jeweils andere fe_users-Datensatz existiert;
   beim Bearbeiten wuerden neu gewaehlte Bilder doppelt angehaengt.
   Gesperrt wird nur, wenn der Submit tatsaechlich abgeschickt wird: FormValidation.js
   (chip_connect_bw_site) setzt form.noValidate = true und bricht einen ungueltigen Submit selbst per
   preventDefault() ab - das "submit"-Event feuert also AUCH bei Validierungsfehlern. Der Listener
   haengt daher bewusst am document (Bubbling-Phase): er laeuft garantiert NACH allen Listenern am
   Formular selbst, unabhaengig von der Ladereihenfolge der Scripts, und sieht so ein bereits
   gesetztes event.defaultPrevented. */
export function initSubmitOnce(form) {
    if (!form) {
        return;
    }

    let submitting = false;

    function setSubmitting(state) {
        submitting = state;
        if (state) {
            form.setAttribute('aria-busy', 'true');
        } else {
            form.removeAttribute('aria-busy');
        }
        form.querySelectorAll('button[type="submit"]').forEach(function (button) {
            button.disabled = state;
        });
    }

    document.addEventListener('submit', function (event) {
        if (event.target !== form) {
            return;
        }
        if (submitting) {
            event.preventDefault();
            return;
        }
        if (event.defaultPrevented) {
            return;
        }
        setSubmitting(true);
    });

    // Zurueck-Navigation aus dem Back-Forward-Cache stellt die Seite samt gesperrtem Button wieder
    // her - dann wieder freigeben, sonst liesse sich das Formular nicht erneut absenden.
    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            setSubmitting(false);
        }
    });
}
